
function calculateScore( courseStatus ){

    if( courseStatus.passed === 0 ){
        return 0;
    }

    const score = Math.round( (courseStatus.passed / courseStatus.scoAmount) * 100 );
    return score / 100;
}

function calculateCompletionStatus( courseStatus ){

    if( courseStatus.completed >= courseStatus.scoAmount ) {
        return "completed";
    }

    if ( courseStatus.completed > 0 || courseStatus.incomplete > 0 || courseStatus.scoAmount > 0 ) {
        return "incomplete";
    }

    return "not attempted";
}

function calculateProgressMeasure( courseStatus ){

    if ( courseStatus.completed > 0 || courseStatus.incomplete > 0) {
        const progressMeasure = Math.round( (courseStatus.passed / courseStatus.scoAmount) * 100 );
        return progressMeasure / 100;
    }

    return 0;
}

function calculateSuccessStatus( courseStatus, masteryScore, completionStatus ){

    if( courseStatus.scoAmount === 0 ) {
        return "unknown";
    }

    const succeeded = calculateScore( courseStatus ) >= masteryScore;

    if( succeeded ) {
        return "passed";
    }

    if( completionStatus === "completed" ) {
        return "failed";
    }

    return "unknown";
}

function calculateExitStatus(completionStatus){
    return (completionStatus === "completed") ? "normal" : "suspend";
}

export const StatusCalculator = {

    calculateStatus: ( courseStatus, masteryScore ) =>{
        const completionStatus = calculateCompletionStatus(courseStatus);
        return {
            score: calculateScore(courseStatus),
            completionStatus: completionStatus,
            successStatus: calculateSuccessStatus( courseStatus, masteryScore, completionStatus ),
            exitStatus: calculateExitStatus( completionStatus ),
            progressMeasure: calculateProgressMeasure(courseStatus)
        };
    }
};
